import { render } from "./SlideView.vue?vue&type=template&id=6c15b95e"
import script from "./SlideView.vue?vue&type=script&lang=js"
export * from "./SlideView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__